import React from 'react';
import cn from 'classnames';
import styles from './styles.css';

export const text = {
  PENDING: 'pending',
  ON_HOLD: 'on hold',
  IN_PROGRESS: 'in progress',
  CANCELLED: 'cancelled',
  COMPLETED: 'completed'
};

const LotStatusText = ({ status, capitalise, colour, className }) => {
  const st = text[status] || status;
  const classes = cn(className, {
    [styles[status.toLowerCase()]]: colour
  });
  return <span className={classes}>{capitalise ? `${st.charAt(0).toUpperCase()}${st.slice(1)}` : st}</span>;
};

export default LotStatusText;



// WEBPACK FOOTER //
// ./src/components/lotStatusText/lotStatusText.jsx